import { Component, OnInit } from '@angular/core';
import { LogService } from '../core/log.service';

@Component({
  selector: 'app-root',
  templateUrl: './app-init.component.html',
  styleUrls: ['./app-init.component.sass']
})
export class AppInitComponent implements OnInit {

  constructor(
    private log: LogService,
  ) { }

  ngOnInit(): void {
    this.log.log('AppInitComponent: ngOnInit url=' + window.location.href);  
  }

}
